var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("save-bar", [
    _c("div", [
      _c("h1", [_vm._v("Add Country")]),
      _c("div", { staticClass: "input-container" }, [
        _c("div", { staticClass: "input-label" }, [_vm._v("Country Name:")]),
        _c(
          "div",
          { staticClass: "main-input" },
          [
            _c("input-component", {
              attrs: { validationObj: _vm.$v.country.countryName },
              model: {
                value: _vm.$v.country.countryName.$model,
                callback: function($$v) {
                  _vm.$set(_vm.$v.country.countryName, "$model", $$v)
                },
                expression: "$v.country.countryName.$model"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "input-container" }, [
        _c("div", { staticClass: "input-label" }, [_vm._v("Country Code:")]),
        _c(
          "div",
          { staticClass: "main-input" },
          [
            _c("input-component", {
              attrs: { validationObj: _vm.$v.country.countryCode },
              model: {
                value: _vm.$v.country.countryCode.$model,
                callback: function($$v) {
                  _vm.$set(_vm.$v.country.countryCode, "$model", $$v)
                },
                expression: "$v.country.countryCode.$model"
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }